import { motion } from "framer-motion";
import QrScanner from "../../components/v6/ScanQR";
import Button from "./../../components/v6/Button";
import { useState } from "react";
import { usePostRedeemStickerMutation } from "../../services/apiSlice";
import { HttpStatusCode } from "axios";

const Step1 = (props) => {
  const { item, handleNext, handleClose, locationId, setLocationId } = props;

  const [isActive, setIsActive] = useState(false);
  const [onRedeem] = usePostRedeemStickerMutation();

  const onClick = async () => {
    try {
      const payload = {
        reward_id: item.reward.reward_id,
        location_id: locationId,
      };

      const response = await onRedeem(payload).unwrap();

      if (response.status === HttpStatusCode.Ok) {
        if (handleNext) handleNext(2);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClose = () => {
    if (handleClose) {
      handleClose();
      setLocationId("");
    }
  };

  const renderDiscountContent = () => {
    return (
      <>
        <h2 className="text-[32px] leading-[38px] max-xs:text-3xl font-bold text-primary text-center">
          Rally Redemption
        </h2>
        <div className="h-[114px] max-xs:h-[95px] flex flex-col justify-center items-center gap-3 bg-[#EDF8B2] rounded-xl [&>p]:text-primary [&>p]:font-bold">
          <p className="text-[32px] leading-[38px] max-xs:text-3xl">
            {item?.reward?.discount_percentage}% discount
          </p>
          <p className="text-lg max-xs:text-base">
            at {item?.reward?.discount_at}
          </p>
        </div>
        {!locationId ? (
          <QrScanner setLocationId={setLocationId} setIsActive={setIsActive} />
        ) : (
          <img
            className="w-auto h-52 object-cover"
            src={
              item?.reward?.reward_image
                ? `${process.env.REACT_APP_URL_IMAGE}/${item?.reward?.reward_image?.file_path}`
                : "/images/brand.jpg"
            }
            alt=""
          />
        )}
      </>
    );
  };

  const renderCoinContent = () => {
    return (
      <>
        <h2 className="text-base font-bold text-center text-primary">
          Scan QR
        </h2>
        {!locationId ? (
          <QrScanner setLocationId={setLocationId} setIsActive={setIsActive} />
        ) : (
          <img
            className="w-auto h-52 object-cover"
            src={
              item?.reward?.reward_image
                ? `${process.env.REACT_APP_URL_IMAGE}/${item?.reward?.reward_image?.file_path}`
                : "/images/brand.jpg"
            }
            alt=""
          />
        )}
        <p className="text-center text-2xl font-bold leading-none text-primary">
          {item?.reward?.reward_quantity} x {item?.reward?.reward_name}
        </p>
        <p className="text-center text-dark-gray leading-none text-lg">
          Exchange for {item?.reward?.reward_quantity}{" "}
          {item?.reward?.reward_name}
        </p>
      </>
    );
  };

  return (
    <motion.div
      key="step1"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col gap-6"
    >
      {item?.reward?.type === "DISCOUNT"
        ? renderDiscountContent()
        : renderCoinContent()}
      <div className="flex flex-col gap-3">
        <Button handleClick={onClick} disabled={!isActive}>
          Redeem Now!
        </Button>
        <Button
          className="bg-transparent shadow-none text-primary"
          handleClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </motion.div>
  );
};

export default Step1;
